// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___3bKG0","action":"styles__action___2L0pt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RepairWizard/components/ModalAutoFixCounter/styles.css
// module id = 2778
// module chunks = 0